import React from "react";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import * as AppUrls from "../../../constants/AppUrls";

const SessionExpiredPOPup = ({ setRedirect, onClose }) => {
    
  const { t } = useTranslation();

  const companyNameClass = localStorage.getItem("company_name") || "default";
  var dir = "ltr";
  if (i18next.language == "ar") {
    dir = "rtl";
  }
  return (
      <div className={`custom-popup custom-scrollable Onboarding-SubmitPopup ${companyNameClass}-CSS`} style={{ height: "140px",width: "400px", direction: dir }}>
      <div className="custom-popup-body pt-2 pb-2">
        <label>{t("sessionclientexpired")}</label>
        <div className="mt-3 mb-2" style={{ textAlign: "center" }}>
          <button
            className="btn custom-btn-cancel"
            onClick={() => {
                setRedirect(AppUrls.onboarding);
                onClose();
            }}>
            {t("ok")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SessionExpiredPOPup;
